// src/theme/atomic/blue.ts
var blue = {
  10: "#001536",
  20: "#002966",
  30: "#003E9C",
  40: "#0054D1",
  45: "#005EEB",
  50: "#0066FF",
  55: "#1A75FF",
  60: "#3385FF",
  70: "#69A5FF",
  80: "#9EC5FF",
  90: "#C9DEFE",
  95: "#EAF2FE",
  99: "#F7FBFF"
};
var blue_default = blue;

export { blue_default as default };
